<template>
    <NuxtLayout name="main-small" :dark="true">
        <div class="container flex items-start !mt-[80px]" :class="css.container">
            <!-- * 菜单 -->
            <div class="sticky top-[40px] t-border-uicolor4 rounded-[4px] px-[40px] py-[24px] w-[280px]" :class="css.menus">
                <div class="text-[20px] text-emphas leading-[36px] font-bold">{{ $t("MainContent") }}</div>
                <div class="flex flex-col items-start mt-[4px]">
                    <template v-for="(menu, index) in menus">
                        <div
                            class="text-[14px] leading-[30px] underline-offset-4 t-delay"
                            :class="[css.menu, id == menu.id && css.active]"
                            @click="methods.move(index)">
                            {{ menu.name }}
                        </div>
                    </template>
                </div>
            </div>

            <!-- * 内容 -->
            <div class="flex-1 ml-[96px]" ref="sections">
                <section class="text-[36px] text-emphas leading-[52px] font-bold">{{ $t("MutationViewer") }}</section>
                <section class="mt-[64px]" data-key="section">
                    <div :class="css.h2">{{ $t("ToolIntroductionAndBackground") }}</div>
                    <div :class="css.content">
                        <div class="text-emphas">{{ $t("MutationViewerTutorials.D1") }}</div>
                    </div>
                </section>

                <section class="mt-[72px]" data-key="section">
                    <div :class="css.h2">{{ $t("DetailedOperatingSteps") }}</div>
                    <div :class="css.content">
                        <div :class="css.h3">{{ $t("MutationViewerTutorials.T1") }}</div>
                        <i18n-t tag="div" scope="global" keypath="OpenABrowserNavigateTo">
                            <template v-slot:name>{{ $t("MutationViewer") }}</template>
                            <template v-slot:href>
                                <ProjectRoute :class="styles.assets" :to="{ name: 'BioVariant' }">
                                    https://rddc.tsinghua-gd.org/zh/tool/variant
                                </ProjectRoute>
                            </template>
                        </i18n-t>

                        <div :class="css.h3" class="!mt-[32px]">{{ $t("MutationViewerTutorials.T2") }}</div>
                        <div :class="css.ordered">
                            <div :class="css.nos"></div>
                            <div :class="css.context">
                                <span class="font-bold text-emphas">{{ $t("MutationViewerTutorials.D2") }}</span>
                                <span>{{ $t("MutationViewerTutorials.D3") }}</span>
                            </div>

                            <div :class="css.nos"></div>
                            <div :class="css.context">
                                <span class="font-bold text-emphas">{{ $t("MutationViewerTutorials.D4") }}</span>
                                <span>{{ $t("MutationViewerTutorials.D5") }}</span>
                            </div>
                        </div>

                        <img v-src="1" />
                        <div :class="css.h3" class="!mt-[32px]">{{ $t("MutationViewerTutorials.T3") }}</div>
                        <div :class="css.ordered">
                            <div :class="css.nos"></div>
                            <div :class="css.context">
                                <span class="font-bold text-emphas">{{ $t("MutationViewerTutorials.D6") }}</span>
                                <span>{{ $t("MutationViewerTutorials.D7") }}</span>
                            </div>

                            <div :class="css.nos"></div>
                            <div :class="css.context">
                                <span class="font-bold text-emphas">{{ $t("MutationViewerTutorials.D8") }}</span>
                                <span>{{ $t("MutationViewerTutorials.D9") }}</span>
                            </div>
                        </div>

                        <img v-src="2" />
                        <div :class="css.h3" class="!mt-[32px]">{{ $t("MutationViewerTutorials.T4") }}</div>
                        <div :class="css.ordered">
                            <div :class="css.nos"></div>
                            <div :class="css.context">
                                <span class="font-bold text-emphas">{{ $t("MutationViewerTutorials.D10") }}</span>
                                <span>{{ $t("MutationViewerTutorials.D11") }}</span>
                            </div>

                            <div :class="css.image">
                                <img v-src="3" />
                            </div>

                            <div :class="css.nos"></div>
                            <div :class="css.context">
                                <div>
                                    <span class="font-bold text-emphas">{{ $t("MutationViewerTutorials.D12") }}</span>
                                    <span>{{ $t("MutationViewerTutorials.D13") }}</span>
                                </div>

                                <div :class="css.disorder">
                                    <div>
                                        <span class="font-bold text-emphas">{{ $t("MutationViewerTutorials.D14") }}</span>
                                        <span>{{ $t("MutationViewerTutorials.D15") }}</span>
                                    </div>
                                </div>

                                <div :class="css.disorder">
                                    <div>
                                        <span class="font-bold text-emphas">{{ $t("MutationViewerTutorials.D16") }}</span>
                                        <span>{{ $t("MutationViewerTutorials.D17") }}</span>
                                    </div>
                                </div>

                                <div :class="css.disorder">
                                    <div>
                                        <span class="font-bold text-emphas">{{ $t("MutationViewerTutorials.D18") }}</span>
                                        <span>{{ $t("MutationViewerTutorials.D19") }}</span>
                                    </div>
                                </div>
                            </div>

                            <div :class="css.image">
                                <img v-src="4" />
                            </div>

                            <div :class="css.nos"></div>
                            <div :class="css.context">
                                <span class="font-bold text-emphas">{{ $t("MutationViewerTutorials.D20") }}</span>
                                <span>{{ $t("MutationViewerTutorials.D21") }}</span>
                            </div>

                            <div :class="css.image">
                                <img v-src="5" />
                            </div>

                            <div :class="css.nos"></div>
                            <div :class="css.context">
                                <span class="font-bold text-emphas">{{ $t("MutationViewerTutorials.D22") }}</span>
                                <span>{{ $t("MutationViewerTutorials.D23") }}</span>
                            </div>

                            <div :class="css.image">
                                <img v-src="6" />
                            </div>

                            <div :class="css.nos"></div>
                            <div :class="css.context">
                                <span class="font-bold text-emphas">{{ $t("MutationViewerTutorials.D24") }}</span>
                                <span>{{ $t("MutationViewerTutorials.D25") }}</span>
                            </div>

                            <div :class="css.image">
                                <img v-src="7" />
                            </div>

                            <div :class="css.nos"></div>
                            <div :class="css.context">
                                <span class="font-bold text-emphas">{{ $t("MutationViewerTutorials.D26") }}</span>
                                <span>{{ $t("MutationViewerTutorials.D27") }}</span>
                            </div>

                            <div :class="css.image">
                                <img v-src="8" />
                            </div>
                        </div>
                    </div>
                </section>

                <section class="mt-[72px]" data-key="section">
                    <div :class="css.h2">{{ $t("Precautions") }}</div>
                    <div :class="css.content">
                        <div :class="css.ordered">
                            <div :class="css.nos"></div>
                            <div :class="css.context">
                                <span class="font-bold text-emphas">{{ $t("MutationViewerTutorials.D28") }}</span>
                                <span>{{ $t("MutationViewerTutorials.D29") }}</span>
                            </div>

                            <div :class="css.nos"></div>
                            <div :class="css.context">
                                <span class="font-bold text-emphas">{{ $t("MutationViewerTutorials.D30") }}</span>
                                <span>{{ $t("MutationViewerTutorials.D31") }}</span>
                            </div>

                            <div :class="css.nos"></div>
                            <div :class="css.context">
                                <span class="font-bold text-emphas">{{ $t("MutationViewerTutorials.D32") }}</span>
                                <span>{{ $t("MutationViewerTutorials.D33") }}</span>
                            </div>

                            <div :class="css.nos"></div>
                            <div :class="css.context">
                                <span class="font-bold text-emphas">{{ $t("MutationViewerTutorials.D34") }}</span>
                                <span>{{ $t("MutationViewerTutorials.D35") }}</span>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="mt-[72px]" data-key="section">
                    <div :class="css.h2">{{ $t("AuxiliaryFunctionsResources") }}</div>
                    <div :class="css.content">
                        <div :class="css.ordered">
                            <div :class="css.nos"></div>
                            <div :class="css.context">
                                <span class="font-bold text-emphas">{{ $t("MutationViewerTutorials.D36") }}</span>
                                <span>{{ $t("MutationViewerTutorials.D37") }}</span>
                            </div>

                            <div :class="css.image">
                                <img v-src="9" />
                            </div>

                            <div :class="css.nos"></div>
                            <div :class="css.context">
                                <span class="font-bold text-emphas">{{ $t("MutationViewerTutorials.D38") }}</span>
                                <span>{{ $t("MutationViewerTutorials.D39") }}</span>
                            </div>

                            <div :class="css.image">
                                <img v-src="10" />
                            </div>

                            <div :class="css.nos"></div>
                            <div :class="css.context">
                                <span class="font-bold text-emphas">{{ $t("MutationViewerTutorials.D40") }}</span>
                                <span>{{ $t("MutationViewerTutorials.D41") }}</span>
                            </div>

                            <div :class="css.image">
                                <img v-src="11" />
                            </div>
                        </div>
                    </div>
                </section>

                <section class="mt-[72px]" data-key="section">
                    <div :class="css.h2">{{ $t("Applications") }}</div>
                    <div :class="css.content">
                        <div :class="css.ordered">
                            <div :class="css.nos"></div>
                            <div :class="css.context">
                                <span class="font-bold text-emphas">{{ useColon($t("ResearchScenario")) }}</span>
                                <span>{{ $t("MutationViewerTutorials.D43") }}</span>
                            </div>

                            <div :class="css.nos"></div>
                            <div :class="css.context">
                                <span class="font-bold text-emphas">{{ useColon($t("ClinicalScenario")) }}</span>
                                <span>{{ $t("MutationViewerTutorials.D45") }}</span>
                            </div>

                            <div :class="css.nos"></div>
                            <div :class="css.context">
                                <span class="font-bold text-emphas">{{ useColon($t("EducationScenario")) }}</span>
                                <span>{{ $t("MutationViewerTutorials.D47") }}</span>
                            </div>

                            <div :class="css.nos"></div>
                            <div :class="css.context">
                                <span class="font-bold text-emphas">{{ useColon($t("IndustryScenario")) }}</span>
                                <span>{{ $t("MutationViewerTutorials.D49") }}</span>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </NuxtLayout>
</template>

<script lang="ts" setup>
//* Vue
import type { Directive } from "vue";
//* 全局函数
import { Nodes } from "@/assets/js";
//* 样式
import css from "../index.module.less";
import styles from "@/assets/style/src/index.module.less";
//* 图片资源导入
const images = import.meta.glob("./src/images/*/*.webp", { query: "url", import: "default" });

//* 插件
const i18n = useI18n();
//* 响应式变量
const id = ref<string>("#summary");
const sections = ref<HTMLDialogElement>();
const menus = ref<{ id: string; name: string }[]>([
    { id: "#summary", name: i18n.t("ToolIntroductionAndBackground") },
    { id: "#steps", name: i18n.t("DetailedOperatingSteps") },
    { id: "#precautions", name: i18n.t("Precautions") },
    { id: "#helper", name: i18n.t("AuxiliaryFunctionsResources") },
    { id: "#sample", name: i18n.t("Applications") },
]);

//* 指令
const vSrc: Directive<HTMLImageElement, string | number> = {
    created: (_node, response, vnode) => {
        images[`./src/images/${i18n.locale.value}/${response.value.toString()}.webp`]?.().then((src) => {
            vnode.el.src = src;
        });
    },
};

//* 函数列表
const methods = {
    move: (index: number) => {
        //* 数据更新
        id.value = menus.value[index].id;
        //* 页面滚动
        const nodes = sections.value?.querySelectorAll("[data-key='section']") || [];
        const node = nodes[index] as HTMLDivElement;
        if (node) {
            window.scrollTo({ top: Nodes.offsetTop(0, node) - 40, behavior: "smooth" });
        }
    },

    // scroll: () => {
    //     //* 数据初始化
    //     const offsetY = window.scrollY;
    //     const header = document.querySelector("header")?.offsetHeight || 0;
    //     const nodes = sections.value?.querySelectorAll("[data-key='section']") || [];
    //     //* 索引初始化
    //     id.value = menus.value[0].id;
    //     //* 循环设置索引
    //     for (let i = 0; i < nodes.length; i++) {
    //         const node = nodes[i] as HTMLDivElement;
    //         if (Nodes.offsetTop(0, node) - header - 40 > offsetY) break;
    //         else {
    //             id.value = menus.value[i].id;
    //         }
    //     }
    // },
};

//* 组件卸载前移除滚动事件
// onBeforeUnmount(() => removeEventListener("scroll", methods.scroll, true));
//* 组件挂载后注册滚动事件
// onMounted(() => {
//     methods.scroll(), addEventListener("scroll", methods.scroll);
// });
</script>
